<template>
  <!--  赛题-->
  <div>
    <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
      <!-- 轮播vue -->

      <!-- 轮播结束 -->
      <div v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(banner, index) in banners" :key="'banner' + index">
            <div class="banner">
              <img :src="banner.image">
              <div class="w1200">
                <div class="txt">
                  <p class="fnt_42">{{ banner.title }}</p>
                  <span class="fnt_16">{{ banner.intro }}</span>

                  <div class="learn_more fnt_16" v-if="banner.linkUrl">
                    <router-link class="learn_more fnt_16" :to="banner.linkUrl">
                      {{
                        globalDataArray.siteTemplateLanguage.system_learn_more }} >
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-bullets" :class="isClient && banners.length > 1 ? '' : 'dpn'" id="sPage">
        </div>
      </div>

      <!-- 第二板块 -->
      <div class="problem_mine">
        <multi-condition-query-new
          :query-object="queryObject"
          :condition-query-list="conditionQueryList"
          :category="category"
          :competition-type-list="competitionTypeList"
          :competition-signup-status="competitionSignupStatus"
          :technical-list="technicalList"
          :competiton-sort-type="competitonSortType"
          :competition-year="competitionYear"
          :my-competition="myCompetition"
          @multiQuery="multiQuery"
          @getMyCompetition="getMyCompetition"
          @getBrowserAndBookmark="getBrowserAndBookmark"
        />
        <div class="w1200">
          <multi-condtion-info-new ref="imgDiv" v-for="comp in competition" :key="comp.id" :show-object="comp" :from-query="fromQuery" :current-time="currentTime" :is-client="isClient" @toSignFun="toSignFun" @addBrowserAndBookmark="addBrowserAndBookmark" :highlight-text="listQuery.s" />
          <div v-if="isClient && competition.length === 0" class="h19px"> <h3></h3></div>
          <!-- 学习赛 -->
          <div class="problem_minebottom" v-if="listQuery.categoryId === '1afbe733655a3a700ac5b1eb33094730'">
            <a href="https://www.devedu.net/" target="_blank">
              <div style="cursor: pointer;">
                <div class="tabulation">
                  <div class="tabulation_left">
                    <img src="../../assets/images/platform.png" alt="提示">
                  </div>
                  <div class="tabulation_right">
                    <div class="right_box">
                      <div class="box_tit1 fnt_24">
                        <a target="_blank" class="item" to="https://www.devedu.net/">
                          开放原子开源大赛在线学习考试平台
                        </a>
                      </div>
                      <div class="box_tit2">
                        <p class="fnt_16"><span>学习工具</span></p>
                        <p class="fnt_16"><span>课程</span></p>
                      </div>
                      <div class="fnt_14">
                        开放原子开源大赛在线学习考试平台是一个便捷、高效的一站式学习工具。这里汇集了丰富多样的开发者课程，满足您全方位的学习需求。同时，平台还提供灵活的在线考试功能，让您随时检验自己的学习成果。无论您身在何处，都能轻松开启学习之旅，实现知识的持续积累与自我价值的不断提升。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="p_page" v-if="isClient && totalnum > 0">
            <a-pagination
              v-model="curpage" :total="totalnum" :page-size="listQuery.pageSize" @change="turnPageFun"
              :hide-on-single-page="true" show-less-items
            />&emsp;&emsp;<span>{{
                                  globalDataArray.siteTemplateLanguage.total }}
              {{ totalnum }} {{ globalDataArray.siteTemplateLanguage.unit }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择报名方式弹窗 -->
    <signway :signway.sync="signway" :cur-info-array.sync="curInfoArray" @itemclick="signtypeFun" />

    <!-- 报名弹窗 -->
    <!--    <formsign :formsign.sync="formsign" :cur-info-array.sync="curInfoArray" @itemclick="formsignFun" /> -->
    <FormsignNew :formsign.sync="formsign" :cur-info-array.sync="curInfoArray" @itemclick="formsignFun" :title-name="globalDataArray.siteTemplateLanguage.to_sign_up" :sub-button="globalDataArray.siteTemplateLanguage.right_away_sign" />

    <formteen :formteen.sync="formteen" :cur-info-array.sync="curInfoArray" @itemclick="formsignFun" /> <!--青年-->

    <!-- 加入团队列表 -->
    <formapply :formapply.sync="formapply" :cur-info-array.sync="curInfoArray" @itemclick="formapplyFun" />

    <!-- 加入团队信息填写弹窗 -->
    <!--    <formmsg
      :formmsg.sync="formmsg" :cur-info-array.sync="curInfoArray" :team-array.sync="teamArray"
      @itemclick="formmsgFun"
    />-->
    <formmsg-edit-new
      :formsign.sync="formmsg" :cur-info-array.sync="curInfoArray" :team-array.sync="teamArray" @itemclick="formmsgFun" :sub-button="globalDataArray.siteTemplateLanguage.submit"
      :title-name="globalDataArray.siteTemplateLanguage.apply_join" :place-write="globalDataArray.siteTemplateLanguage.please_write_info"
    />

    <!-- 参赛用户服务协议 -->
    <formxieyi :formxieyi.sync="formxieyi" :cur-info-array.sync="curInfoArray" :agreement-content="agreementContent" @itemclick="formxieyiFun" />

    <!-- 参赛须知-->
    <form-entry :form-entry.sync="formEntry" :cur-info-array.sync="curInfoArray" :notice-content="noticeContent" @itemclick="formEntryFun" />

    <!-- 官方群二维码弹框-->
    <q-r-code-new :qr-code.sync="qrCode" :cur-info-array.sync="curInfoArray" />
  </div>
</template>

<script>
import { stringToDateTime } from '@/utils/util'
import Cookies from 'js-cookie'
import { message } from 'ant-design-vue'
import {
  addBookmark,
  addBrowserAndBookmark, getAllSession, getBrowserAndBookmark,
  getCategoryList,
  getCompetitionList,
  getCompetitionListForZone, getMyCompetition,
  getTechnicalList, queryByParentId
} from '@/api/saiti'
import { getAdList, getCompetitionDict } from '@/api/api'
import { getZoneDetail } from '@/api/zone'
import MultiConditionQueryNew from '@/views/saiti/components/MultiCOnditionQueryNew.vue'
import MultiCondtionInfoNew from '@/views/saiti/components/MultiCondtionInfoNew.vue'
import QRCodeNew from '@/components/global/qrcodenew/index.vue'
import FormEntry from '@/components/global/formEntry/index.vue'
import FormsignNew from '@/components/global/formsign/FormsignNew.vue'
import FormmsgNew from '@/components/global/formmsg/FormmsgNew.vue'
import FormmsgEditNew from '@/components/global/formmsg/FormmsgNew.vue'

export default {
  name: 'Saiti',
  components: { FormmsgEditNew, FormsignNew, MultiConditionQueryNew, QRCodeNew, MultiCondtionInfoNew, FormEntry, FormmsgNew },
  data() {
    return {
      title: this.globalDataArray.siteNavigation[1].title + '-' + this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteNavigation[1].keywords,
      keywords: this.globalDataArray.siteNavigation[1].description,
      banners: [],
      category: [],
      technicalList: [],
      competition: [],
      swiperOption: {
        autoplay: 5000,
        initialSlide: 0,
        pagination: '.swiper-pagination'
      },
      listQuery: {
        categoryId: '',
        page: 1,
        pageSize: 20,
        technicalId: '',
        signupStatus: '',
        year: '',
        sortType: '',
        isManaged: '',
        s: '',
        type: '',
        sortBonus: '',
        sortTime: '',
        sessionIds: '',
        isMember:　'',
        recordType: '',
        sortTeams: ''
      },
      currentTime: 0, // SSR兼容：统一初始为0，mounted后设置
      curpage: 1,
      totalnum: 0,
      isClient: false, // 客户端标识

      signway: false,
      signtype: '',

      formsign: false,
      formteen: false,
      formen: false,
      formenteen: false,

      formapply: false,

      formmsg: false,
      formEntry: false,
      qrCode: false,
      curInfoArray: {
        categoryId: '',
        competitionId: '',
        templateId: '',
        currentLanguge: '',
        teamsUsers: '',
        teams: '',
        parentId: '',
        zoneId: ''

      },
      teamArray: {},
      formxieyi: false,

      imgwidhth: 0,

      fromQuery: '',
      dictCodeList: {
        competition_type: 'competition_type',
        competition_signup_status: 'competition_signup_status',
        competiton_sort_type: 'competiton_sort_type',
        competition_year: 'competition_year',
        my_competition: 'my_competition'
      },
      conditionQueryList: [],
      competitionTypeList: [],
      competitionSignupStatus: [],
      competitonSortType: [],
      competitionYear: [],
      myCompetition: [],
      queryObject: {
        type: '00'
      },
      agreementContent: '',
      noticeContent: ''
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (to.query.zone_id) {
      this.$nextTick(() => {
        this.initZone()
      })
    }
    else {
      this.$nextTick(() => {
        this.init()
      })
    }

    if (to.query.from) {
      this.fromQuery = to.query.from
    }

    next()
  },

  mounted() {
    // 设置客户端状态，确保SSR水合一致性
    this.isClient = true
    this.$nextTick(() => {
      // 设置正确的时间状态
      this.currentTime = new Date().getTime()
    })

    if (this.$route.query.zone_id) {
      this.initZone()
    }
    else {
      this.init()
    }

    if (typeof window !== 'undefined') {
      window.onresize = () => {
        this.$nextTick(() => {
          if (this.$refs.imgDiv && this.$refs.imgDiv.length > 0) {
            this.imgwidhth = this.$refs.imgDiv[0].offsetWidth
          }
        })
      }
    }

    if (typeof document === 'object') {
      document.documentElement.scrollTop = 0
    }

    if (this.$route.query.from) {
      this.fromQuery = this.$route.query.from
    }
  },
  computed: {
    imgheight() {
      return Math.floor(this.imgwidhth * 0.65)
    },

    showCategory() {
      return !this.$route.query.zone_id
    }
  },
  methods: {
    init() {
      this.listQuery.page = 1

      const adParam = 'alias=competition_banner'

      getAdList(adParam).then(res => {
        if (res.success) {
          this.banners = res.result
          this.$nextTick(() => {
            // 移除直接DOM操作，避免SSR水合不匹配
            if (typeof document === 'object' && this.banners != '' && this.banners != null) {
              try {
                const sPageElement = document.getElementById('sPage')
                if (sPageElement && sPageElement.childNodes && sPageElement.childNodes[0]) {
                  sPageElement.childNodes[0].classList.add('swiper-pagination-bullet-active')
                }
              } catch (error) {
                console.warn('轮播图分页器激活状态设置失败:', error)
              }
            }
          })
        }
      })
      // 获取赛事分类
      getCategoryList().then(res => {
        if (res.success) {
          this.category = res.result
          const newItem = {
            'parentId': '',
            'title': this.globalDataArray.siteTemplateLanguage.all_list_data
          }
          this.category.unshift(newItem)
        }
      })
      // 获取技术类别
      getAllSession('language=' + this.globalDataArray.siteInfo.language).then(res => {
        if (res.success) {
          this.competitionYear = res.result.map(item => ({
            itemValue: item.id,
            itemText: item.title,
            isDisplay: item.isDisplay
          }))

          const displayedItemValues = this.competitionYear
            .filter(item => item.isDisplay === '0')
            .map(item => item.itemValue)
            .join(',')

          const nonDisplayedItems = this.competitionYear.filter(item => item.isDisplay === '1')

          this.competitionYear = [{
            itemValue: '',
            itemText: this.globalDataArray.siteTemplateLanguage.all_list_data
          }, ...nonDisplayedItems]
          if (displayedItemValues !== '') {
            this.competitionYear.push({
              itemValue: displayedItemValues,
              itemText: this.globalDataArray.siteTemplateLanguage.previous_tournaments
            })
          }
          console.log(this.competitionYear, 'this.competitionYear')
        }
      })
      // 赛题类别  赛题状态  赛题排序  赛事年份  我的赛事
      const params = 'dictCode=competition_type,competition_signup_status,competiton_sort_type,my_competition'
      getCompetitionDict(params).then(res => {
        if (res.success) {
          console.log(res.result, 'res.result')
          const filterList = res.result[0].list.filter(item => item.itemValue !== '00')
          res.result[0].list = filterList
          console.log(filterList, 'filterList')
          this.conditionQueryList = res.result
          console.log(res.result, 'conditionQueryList')
          if (this.conditionQueryList.length > 0) {
            // 创建映射关系表
            const dictCodeMap = {
              [this.dictCodeList.competition_type]: {
                target: 'competitionTypeList',
                specialType: true
              },
              [this.dictCodeList.competition_signup_status]: {
                target: 'competitionSignupStatus'
              },
              [this.dictCodeList.competiton_sort_type]: {
                target: 'competitonSortType'
              },
              [this.dictCodeList.my_competition]: {
                target: 'myCompetition'
              }
            }
            // 创建通用默认项
            const createDefaultItem = () => ({
              itemValue: '',
              itemText: this.globalDataArray.siteTemplateLanguage.all_list_data
            })
            this.conditionQueryList.forEach(item => {
              const config = dictCodeMap[item.dictCode]
              if (!config) return
              // 添加默认项
              const defaultItem = config.specialType ? { ...createDefaultItem(), itemValue: '00' }
                : createDefaultItem()
              item.list.unshift(defaultItem)
              // 动态赋值到对应属性
              this[config.target] = item.list
            })
          }
        }
      })
      // 获取技术类别
      getTechnicalList().then(res => {
        if (res.success) {
          this.technicalList = res.result
          const newItem = {
            'parentId': '',
            'title': this.globalDataArray.siteTemplateLanguage.all_list_data
          }
          this.technicalList.unshift(newItem)
        }
      })

      if (this.$route.query.parentId != '' && this.$route.query.parentId != undefined) {
        const id = this.$route.query.parentId
        this.changeCategory(id)

        if (typeof document === 'object') {
          document.documentElement.scrollTop = 0
        }
      } else {
        this.getCompetitionList(this.listQuery)
      }
    },

    initZone() {
      this.listQuery.page = 1

      getZoneDetail('parentId=' + this.$route.query.zone_id).then(res => {
        if (res.success) {
          this.banners = [{
            image: res.result.banner
          }]
          this.$nextTick(() => {
            // 移除直接DOM操作，避免SSR水合不匹配
            if (typeof document === 'object' && this.banners != '' && this.banners != null) {
              try {
                const sPageElement = document.getElementById('sPage')
                if (sPageElement && sPageElement.childNodes && sPageElement.childNodes[0]) {
                  sPageElement.childNodes[0].classList.add('swiper-pagination-bullet-active')
                }
              } catch (error) {
                console.warn('轮播图分页器激活状态设置失败:', error)
              }
            }
          })
        }
      })

      // 获取赛事分类
      getCategoryList().then(res => {
        if (res.success) {
          this.category = res.result
          const newItem = {
            'parentId': '',
            'title': this.globalDataArray.siteTemplateLanguage.all_list_data
          }
          this.category.unshift(newItem)
        }
      })
      // 获取技术类别
      getAllSession('language=' + this.globalDataArray.siteInfo.language).then(res => {
        if (res.success) {
          this.competitionYear = res.result.map(item => ({
            itemValue: item.id,
            itemText: item.title,
            isDisplay: item.isDisplay
          }))

          const displayedItemValues = this.competitionYear
            .filter(item => item.isDisplay === '0')
            .map(item => item.itemValue)
            .join(',')

          const nonDisplayedItems = this.competitionYear.filter(item => item.isDisplay === '1')

          this.competitionYear = [{
            itemValue: '',
            itemText: this.globalDataArray.siteTemplateLanguage.all_list_data
          }, ...nonDisplayedItems]
          if (displayedItemValues !== '') {
            this.competitionYear.push({
              itemValue: displayedItemValues,
              itemText: this.globalDataArray.siteTemplateLanguage.previous_tournaments
            })
          }
          console.log(this.competitionYear, 'this.competitionYear')
        }
      })
      // 赛题类别  赛题状态  赛题排序  赛事年份  我的赛事
      const params = 'dictCode=competition_type,competition_signup_status,competiton_sort_type,my_competition'
      getCompetitionDict(params).then(res => {
        if (res.success) {
          // console.log(res.result, 'res.result')
          // const filterList = res.result[0].list.filter(item => item.itemValue !== '00')
          // res.result[0].list = filterList
          // console.log(filterList, 'filterList')
          this.conditionQueryList = res.result
          console.log(res.result, 'conditionQueryList')
          if (this.conditionQueryList.length > 0) {
            // 创建映射关系表
            const dictCodeMap = {
              [this.dictCodeList.competition_type]: {
                target: 'competitionTypeList',
                specialType: true
              },
              [this.dictCodeList.competition_signup_status]: {
                target: 'competitionSignupStatus'
              },
              [this.dictCodeList.competiton_sort_type]: {
                target: 'competitonSortType'
              },
              [this.dictCodeList.my_competition]: {
                target: 'myCompetition'
              }
            }
            // 创建通用默认项
            const createDefaultItem = () => ({
              itemValue: '',
              itemText: this.globalDataArray.siteTemplateLanguage.all_list_data
            })
            this.conditionQueryList.forEach(item => {
              const config = dictCodeMap[item.dictCode]
              if (!config) return
              // 过滤掉 itemValue 为 "00" 的项
              const filteredList = item.list.filter(item => item.itemValue !== '00')
              // 添加默认项
              const defaultItem = config.specialType ? { ...createDefaultItem(), itemValue: '00' }
                : createDefaultItem()
              filteredList.unshift(defaultItem)
              // 动态赋值到对应属性
              this[config.target] = filteredList
            })
          }
        }
      })
      // 获取技术类别
      getTechnicalList().then(res => {
        if (res.success) {
          this.technicalList = res.result
          const newItem = {
            'parentId': '',
            'title': this.globalDataArray.siteTemplateLanguage.all_list_data
          }
          this.technicalList.unshift(newItem)
        }
      })

      this.category = []

      // this.getCompetitionListForZone()
      this.getCompetitionList(this.listQuery)
    },

    changeCategory(id) {
      const that = this
      that.listQuery.categoryId = id == -1 ? '' : id
      that.listQuery.page = 1
      this.getCompetitionList(this.listQuery)
    },

    changeTechnical(id) {
      this.listQuery.technicalId = id == -1 ? '' : id
      this.listQuery.page = 1
      this.getCompetitionList(this.listQuery)
    },

    multiQuery(queryParams) {
      this.listQuery = queryParams
      if (queryParams.myCompetition) {
        console.log()
      }
      this.getCompetitionList(queryParams)
    },

    getCompetitionList(params) {
      const that = this
      let multiParams = ''
      if (params) {
        if (params.type && params.type === '00') {
          params.type = ''
        }
        multiParams = 'categoryId=' + params.categoryId + '&page=' + params.page + '&pageSize=' + params.pageSize + '&technicalId=' + params.technicalId + '&type=' +
            params.type + '&signupStatus=' + params.signupStatus + '&sessionIds=' + params.sessionIds + '&isManaged=' + params.isManaged + '&s=' + encodeURIComponent(params.s) +
            '&sortBonus=' + params.sortBonus + '&sortTime=' + params.sortTime + '&sortTeams=' + params.sortTeams + '&isMember=' + params.isMember + '&recordType=' + params.recordType
        if (this.$route.query.zone_id) {
          multiParams += '&zoneId=' + this.$route.query.zone_id
        }
      } else {
        multiParams = '&page=' + that.listQuery.page + '&pageSize=' + that.listQuery.pageSize
      }
      getCompetitionList(multiParams).then(res => {
        if (res.success && res.result != '' && Object.keys(res.result).length > 0) {
          that.totalnum = res.result.total
          that.curpage = res.result.current
          that.competition = res.result.records
          that.processCompetitionItem(that.competition)
          console.log(this.competition, 'this.competition')

          that.$nextTick(() => {
            if (this.$refs.imgDiv && this.$refs.imgDiv.length > 0) {
              that.imgwidhth = that.$refs.imgDiv[0].offsetWidth
            }
          })
        }
      })
    },

    processCompetitionItem(component) {
      component.forEach(item => {
        if (item.mark) {
          item.mark = item.mark.split(/[,，]/).filter(item => item.trim())
        }
        if (item.organizersLogo) {
          item.organizersLogo = item.organizersLogo.split(/[,，]/).filter(item => item.trim())
        }
        if (item.organizers) {
          item.organizers = item.organizers.split(/[,，]/).filter(item => item.trim())
        }
        if (item.endUtcTime) {
          const localEndtimeStr = new Date(item.endUtcTime).getTime()
          item.localEndtime = stringToDateTime(localEndtimeStr)
          item.localEndtimeStr = localEndtimeStr
        }
        item.ccompetitions?.forEach(res => {
          res.localEndtimeStr = new Date(res.endUtcTime).getTime()
          if (res.mark) {
            res.mark = res.mark.split(/[,，]/).filter(item => item.trim())
          }
          if (res.organizersLogo) {
            res.organizersLogo = res.organizersLogo.split(/[,，]/).filter(item => item.trim())
          }
          if (res.organizers) {
            res.organizers = res.organizers.split(/[,，]/).filter(item => item.trim())
          }
        })
      })
    },

    async addBrowserAndBookmark(params, showObject) {
      const newObj = 'type=' + params.type + '&parentcompetitionId=' + params.parentcompetitionld + '&competitionId=' + params.competitionld
      const res = await addBookmark(newObj)
      if (res.success) {
        if (params.type === '3') {
          this.$message.success(this.globalDataArray.siteTemplateLanguage.unsubscribed_successfully)
        } else {
          this.$message.success(this.globalDataArray.siteTemplateLanguage.collection_successful)
        }
        console.log(this.listQuery)
        const par = this.listQuery
        this.getCompetitionList(par)
      }
    },
    getMyCompetition(param) {
      const that = this
      const params = 'page=' + param.page + '&pageSize=' + param.pageSize
      getMyCompetition(params).then(res => {
        if (res.success && res.result != '' && Object.keys(res.result).length > 0) {
          that.totalnum = res.result.total
          that.curpage = res.result.current
          that.competition = res.result.records
          that.processCompetitionItem(that.competition)

          that.$nextTick(() => {
            if (this.$refs.imgDiv && this.$refs.imgDiv.length > 0) {
              that.imgwidhth = that.$refs.imgDiv[0].offsetWidth
            }
          })
        }
      })
    },
    getBrowserAndBookmark(param) {
      const that = this
      const params = 'page=' + param.page + '&pageSize=' + param.pageSize + '&recordType=' + param.recordType
      getBrowserAndBookmark(params).then(res => {
        if (res.success && res.result != '' && Object.keys(res.result).length > 0) {
          that.totalnum = res.result.total
          that.curpage = res.result.current
          that.competition = res.result.records
          that.processCompetitionItem(that.competition)

          that.$nextTick(() => {
            if (this.$refs.imgDiv && this.$refs.imgDiv.length > 0) {
              that.imgwidhth = that.$refs.imgDiv[0].offsetWidth
            }
          })
        }
      })
    },

    getCompetitionListForZone() {
      const that = this
      const param = 'zoneId=' + this.$route.query.zone_id + '&page=' + that.listQuery.page + '&pageSize=' + that.listQuery.pageSize

      getCompetitionListForZone(param).then(res => {
        if (res.success && res.result != '' && Object.keys(res.result).length > 0) {
          that.totalnum = res.result.total
          that.curpage = res.result.current
          that.competition = res.result.records
          that.processCompetitionItem(that.competition)

          that.$nextTick(() => {
            if (this.$refs.imgDiv && this.$refs.imgDiv.length > 0) {
              that.imgwidhth = that.$refs.imgDiv[0].offsetWidth
            }
          })
        }
      })
    },

    turnPageFun(e) {
      this.listQuery.page = e
      this.getCompetitionList(this.listQuery)
    },

    async toSignFun(templateId, categoryId, competitionId, teamsUsers, teams, parentId, zoneId, agreementId, noticeId, qrImage) {
      const that = this
      that.curInfoArray.templateId = templateId
      that.curInfoArray.categoryId = categoryId
      that.curInfoArray.competitionId = competitionId
      that.curInfoArray.teamsUsers = teamsUsers
      that.curInfoArray.teams = teams
      that.curInfoArray.parentId = parentId
      that.curInfoArray.zoneId = zoneId
      that.curInfoArray.agreementId = agreementId
      that.curInfoArray.noticeId = noticeId
      that.curInfoArray.qrImage = qrImage
      if (Cookies.get('DEFAULT_LANG') != '' && Cookies.get('DEFAULT_LANG') != undefined) {
        that.curInfoArray.currentLanguge = Cookies.get('DEFAULT_LANG')
      } else {
        that.curInfoArray.currentLanguge = 'zh_CN'
      }

      let token = ''
      const saitiAccessInfo = Cookies.get('saiti_access_info')
      if (saitiAccessInfo != '' && saitiAccessInfo != undefined && saitiAccessInfo != null) {
        token = JSON.parse(saitiAccessInfo).token
      }
      const paTemp = 'language=' + this.globalDataArray.siteInfo.language + '&templateId=' + templateId
      const res = await queryByParentId(paTemp)
      if (res.success) {
        this.agreementContent = res.result.agreementContent
        this.noticeContent = res.result.noticeContent
      }
      if (token != '' && token != undefined) {
        that.formxieyi = true
      } else {
        that.handleLogin()
      }
    },
    signtypeFun(res) {
      const that = this
      if (res == '1') {
        that.formsign = true
      }

      if (res == '2') {
        that.formapply = true
      }
    },

    formsignFun(num, arr) {
      const that = this
      if (num === '1') {
        message.success(that.globalDataArray.siteTemplateLanguage.competition_signup_success_tips)
        that.competition.forEach((item, index) => {
          if (item.ccompetitions) {
            item.ccompetitions.forEach((item2, index2) => {
              if (item2.id === arr.competitionId) {
                item2.isSignup = '2'
                if (item2.teams) {
                  item2.teams += 1
                } else {
                  item2.teams = '1'
                }
              }
            })
          } else {
            if (item.parentId === arr.competitionId) {
              item.isSignup = '2'
              if (item.teams) {
                item.teams += 1
              } else {
                item.teams = '1'
              }
            }
          }
        })
        this.qrCode = true
        this.getCompetitionList(this.listQuery)
      }

      if (num === '2') {
        this.signway = true
      }
    },

    formapplyFun(res) {
      const that = this
      if (res.clickType == '1') {
        that.teamArray = res
        that.formmsg = true
      } else {
        // that.signway = true
      }
    },

    formmsgFun(res) {
      const that = this
      if (res == '1') {
        this.qrCode = true

        that.competition.forEach((item, index) => {
          if (item.parentId == that.teamArray.competitionId) {
            item.isSignup = '2'
          }
        })
      }

      if (res == '2') {
        this.formapply = true
      }
    },
    formxieyiFun(res) {
      if (res == '1') {
        this.formEntry = true
      }
    },
    formEntryFun(res) {
      if (res == '1') {
        this.signway = true
      }
    },

    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.atomgit.com', expires: 180, path: '/', secure: true })
      location.href = this.logAuthUrl
    }
  },
  metaInfo() {
    let title = ''
    let description = ''
    let keywords = ''
    if (this.globalDataArray.siteNavigation[1].title != '' && this.globalDataArray.siteNavigation[1].title != null && this.globalDataArray.siteNavigation[1].title != ' ') {
      title = this.globalDataArray.siteNavigation[1].title + '-' + this.globalDataArray.siteInfo.title
    } else {
      title = this.globalDataArray.siteInfo.title
    }
    if (this.globalDataArray.siteNavigation[1].description != '' && this.globalDataArray.siteNavigation[1].description != null) {
      description = this.globalDataArray.siteNavigation[1].description
    } else {
      description = this.globalDataArray.siteInfo.description
    }
    if (this.globalDataArray.siteNavigation[1].keywords != '' && this.globalDataArray.siteNavigation[1].keywords != null) {
      keywords = this.globalDataArray.siteNavigation[1].keywords
    } else {
      keywords = this.globalDataArray.siteInfo.keywords
    }
    return {
      title: title,
      meta: [
        { vmid: 'description', name: 'description', content: description },
        { vmid: 'keywords', name: 'keywords', content: keywords }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/problem.css';
.problem_mine {
  padding-top: 0;
}
</style>
